import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const kbdVariants = cva(
  'inline-flex h-5 min-w-5 items-center justify-center rounded-sm border border-border-subtle bg-muted px-1.5 font-mono text-[0.625rem] font-medium uppercase leading-none text-muted-foreground',
  {
    variants: {
      context: {
        default: '',
        modal:
          'bg-[var(--color-neutral-1000-70)] text-[var(--color-neutral-25)] border-none',
      },
    },
    defaultVariants: {
      context: 'default',
    },
  }
);

const Kbd = React.forwardRef<
  HTMLElement,
  React.HTMLAttributes<HTMLElement> & VariantProps<typeof kbdVariants>
>(({ className, children, context = 'default', ...props }, ref) => (
  <kbd ref={ref} className={cn(kbdVariants({ context }), className)} {...props}>
    {children}
  </kbd>
));

Kbd.displayName = 'Kbd';

export { Kbd };
export default Kbd;
